<!--<div
  *ngIf="prop && userHelper.canUpdateProperty(prop)"
  class="container-fluid d-flex flex-row-reverse mt-2 mb-2"
>
  <button mat-mini-fab color="primary" mat-icon-button (click)="addConsumptions()">
    <mat-icon appTooltip="Ajouter des relevés de consommation">add</mat-icon>
  </button>
</div>-->
<ng-container *ngIf="capabilities">
  <div class="container-fluid" *ngIf="capabilities.length > 0; else noConsumption">
    <div class="row mb-3">
      <div class="col-12 col-lg-6 mb-4">
        <h5 class="mb-2">Voir les consommations</h5>
        <mat-slide-toggle *ngFor="let capability of capabilities" #consumptionTypes [id]="capability.type"
          class="col-sm-2 mt-1" color="accent" [checked]="selectedConsumptionTypes.includes(capability.type)"
          (change)="consumptionTypesChanged($event)">{{
          trackingHelper.getConsumptionTypeName(capability.type) +
          ' (' +
          trackingHelper.getConsumptionTypeUnit(capability.type) +
          ')'
          }}</mat-slide-toggle>
      </div>
      <div class="col-12 col-lg-6">
        <h5 class="mb-2">Par</h5>
        <mat-radio-group #timeStep class="pl-3" aria-label="Pas de temps" (change)="timeStepChanged($event)">
          <mat-radio-button class="mr-1" value="MONTH" [checked]="selectedTimeStep === 'MONTH'">Mois</mat-radio-button>
          <mat-radio-button class="ml-1" value="YEAR" [checked]="selectedTimeStep === 'YEAR'">Années</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <div>
      <div [style.visibility]="selectedTimeStep === 'MONTH' ? 'visible' : 'hidden'"
        class="d-flex justify-content-center overflow-auto">
        <button *ngFor="let year of yearRange" mat-flat-button class="m-2"
          [color]="year === currentYear ? 'accent' : 'primary'" [appTooltip]="
            year === currentYear ? 'Année ' + year + ' affichée' : 'Montrer l\'année ' + year
          " (click)="yearChanged(year)">
          {{ year }}
        </button>
      </div>
    </div>

    <!--  CHART -->
    <div class="container-fluid">
      <google-chart class="noverflow w-100" #chart [type]="chartType" [dynamicResize]="true" [data]="chartData"
        [options]="options" [columns]="columns" (ready)="onChartReady()"></google-chart>
      <div *ngFor="let bar of eventsBar">
        <mat-icon [ngStyle]="bar.iconStyle" [appTooltip]="
            bar.text.length > 1
              ? bar.text.length + ' événements sont survenus'
              : '1 événement est survenu'
          " color="accent" [mdbPopover]="detailTemplate" trigger="focus" tabindex="0"
          class="event-icon">battery_charging_full</mat-icon>
        <div [ngStyle]="bar.barStyle"></div>
        <ng-template #detailTemplate>
          <ul class="pl-3">
            <li *ngFor="let text of bar.text">{{ text }}</li>
          </ul>
        </ng-template>
      </div>
    </div>
  </div>
  <ng-template #noConsumption>
    <div class="container-fluid text-center mt-5">
      <p class="text-white mt-5">
        Enregistrez vos relevés de consommation en cliquant sur
      </p>
      <p>
        <button class="mt-2 white" mat-mini-fab color="primary" (click)="addConsumptions()">
          <mat-icon aria-label="Ajouter des relevés de consommation">add</mat-icon>
        </button>
      </p>
    </div>
  </ng-template>
</ng-container>